<template>
  <div>
    <ion-header translucent>
      <ion-toolbar>
        <ion-title>Adding to Your Order</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="closeModal()">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen padding>
      <form @submit.prevent="handleAddToOrder()">
        <ion-list>
          <ion-item data-cy="add-to-order-menu-item">
            <ion-label>
              {{ item.name }}
              <p v-if="item.price">{{ item.price | usd }}</p>
            </ion-label>
            <ion-select
              interface="alert"
              placeholder="Quantity"
              :value="quantity"
              @ionChange="quantity = $event.target.value"
            >
              <ion-select-option value="1">1</ion-select-option>
              <ion-select-option value="2">2</ion-select-option>
              <ion-select-option value="3">3</ion-select-option>
              <ion-select-option value="4">4</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item v-if="item.options" data-cy="add-to-order-option">
            <ion-label>{{ item.options.name }}</ion-label>
            <ion-select
              placeholder="Choose"
              :value="optionValueId"
              @ionChange="optionValueId = $event.target.value"
            >
              <ion-select-option
                v-for="value in item.options.values"
                :key="`option-value-${value.id}`"
                :value="value.id"
              >
                {{ value.name }}
                <span v-if="value.price">- {{ value.price | usd }}</span>
              </ion-select-option>
            </ion-select>
          </ion-item>
          <input-box
            :validator="$v.instructions"
            data-cy="add-to-order-instructions"
            v-model="instructions"
            :errorMessages="{ maxLength: 'Please limit to 255 characters.' }"
          >
            Food allergies, condiment preferences, etc
          </input-box>
        </ion-list>
        <div class="ion-padding">
          <submit-button
            :submitting="submitting"
            :disabled="!canSubmit()"
            data-cy="add-to-order-submit-button"
          >
            Add to Order
          </submit-button>
        </div>
      </form>
    </ion-content>
  </div>
</template>

<script>
import submittable from "@/mixins/submittable";
import maxLength from "vuelidate/lib/validators/maxLength";

export default {
  mixins: [submittable],

  props: {
    closeModal: {
      required: true,
      type: Function
    },
    addItemToOrder: {
      required: true,
      type: Function
    },
    item: {
      required: true,
      type: Object
    }
  },

  data: function() {
    return {
      quantity: 1,
      instructions: "",
      optionValueId: ""
    };
  },

  methods: {
    handleAddToOrder() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        // this should never happen, but you never know
        if (!this.canSubmit()) {
          return false;
        }

        this.addItemToOrder({
          id: this.item.id,
          quantity: this.quantity,
          instructions: this.instructions,
          optionValueId: this.optionValueId
        });

        this.closeModal();
      }
    },

    // probably could be created as a validator
    canSubmit() {
      return !this.item.options || Boolean(this.optionValueId);
    }
  },

  validations: {
    instructions: {
      maxLength: maxLength(255)
    }
  }
};
</script>
